var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"media"}},[_c('v-card',{staticClass:"imageTop",attrs:{"width":"100%","height":"400","dark":""}},[_c('v-img',{attrs:{"src":require("../assets/img/1x/MediaBoard.png"),"height":"100%"}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }